import React from "react";
import Modal from "react-modal";
import PropTypes from "prop-types";

function LinkModal({ isOpen, closeModal, linkUrl }) {
  return (
    <Modal
      className="popup"
      overlayClassName="popup__overlay"
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Link Modal"
    >
      <img src={linkUrl} alt={linkUrl} />
    </Modal>
  );
}

LinkModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  linkUrl: PropTypes.string.isRequired,
};

export default LinkModal;



// WEBPACK FOOTER //
// ./components/common/LinkModal.jsx